import { StorageService } from '@csp/web-storage';

const DEBUG_CMS_MODE = 'DEBUG_CMS_MODE';

export const isDebugCmsModeActive = (): boolean => StorageService.sessionStorage.getItem(DEBUG_CMS_MODE) === 'true';

export const toggleDebugCmsMode = (): void => {
  StorageService.sessionStorage.setItem(DEBUG_CMS_MODE, String(!isDebugCmsModeActive()));
};
